<template>
  <div style="padding-top: 100px">
    <PageContainer>
      <h1 class="text-center mb-12">Whoops! How did that happen?</h1>
      <v-layout justify-center>
        <v-card class="pa-6" width="600px">
          <v-card-title class="mb-4">
            <h1 class="secondary--text text-center width-100">403</h1>
          </v-card-title>
          <p class="text-center">
            Looks like you attempted to execute a forbidden operation.
          </p>
          <p class="text-center">
            We suggest you go to your home page to avoid any issues.
          </p>
          <v-card-actions>
            <v-btn block color="secondary" @click="onClicked"
              >Go to my Home Page</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-layout>
    </PageContainer>
  </div>
</template>

<script>
import { navigation } from "../../router";

export default {
  methods: {
    onClicked() {
      this.$router.push(navigation.main.reports.index);
    },
  },
};
</script>
